import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getPatientsJobAndHealth () {
   return Api().get("/patient-health-and-jobs");
},
  updatePatientJobAndHealth (params) {
    return Api().put("/patient-health-and-jobs",params);
  },
  addPatientJobAndHealth (params) {
    return Api().post("/patient-health-and-jobs",params);
  },
  getPatientJobAndHealth (params) {
    return Api().get("/patient-health-and-jobs/"+params);
  },
  deletePatientJobAndHealth (params) {
    return Api().delete("/patient-health-and-jobs/"+params);
  },
  getPatientJobAndHealthByRouteSheets(params){
    return Api().get("/patient-health-and-jobs-by-route-sheet/"+params);
  },

}



// WEBPACK FOOTER //
// ./src/services/PatientHealthAndJobService.js